import React from "react";
import { Button, Group, Modal, Stack, Text } from "@mantine/core";
import { SalonDocument } from "../../types/salonDocument";
import { documentListDisplayName } from "../../utils/clientDocumentUploadKey";

interface ClientDocumentsDeleteModalProps {
  opened: boolean;
  target: SalonDocument | null;
  deleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function ClientDocumentsDeleteModal({
  opened,
  target,
  deleting,
  onClose,
  onConfirm,
}: ClientDocumentsDeleteModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Delete document"
      centered
      size="sm"
    >
      <Stack>
        <Text size="sm">
          Delete &ldquo;
          {target ? documentListDisplayName(target) : ""}&rdquo; and all its
          versions? This cannot be undone.
        </Text>
        <Group justify="flex-end" gap="sm">
          <Button variant="subtle" onClick={onClose}>
            Cancel
          </Button>
          <Button color="red" loading={deleting} onClick={onConfirm}>
            Delete
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
